<template>
  <div class="innovate">
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
        <div class="top-banner-center">
          <div
            class="wow animate__animated animate__zoomIn banner-btn"
            @click="onClickLookMore"
          >服务咨询</div>
        </div>
      </div>
    </div>
    <!-- 知产创造 + 知产运用 -->
    <div class="box-create-apply" id="knowledge1">
      <div class="create-apply-con">
        <div class="create-con">
          <div class="create-apply-title">知产创造</div>
          <div class="create-apply-content">
            <div class="empty" v-if="createList.length == 0">暂无数据</div>
            <div
              class="create-apply-item"
              v-for="(item, index) in createList"
              :key="index"
              :style="{ backgroundImage: `url(${item.pic})` }"
            >
              <div class="create-apply-bottom">{{ item.title }}</div>
              <div class="learnMore" @click="innovateDetail(item.uuid)">了解更多</div>
            </div>
          </div>
        </div>
        <div class="apply-con">
          <div class="create-apply-title">知产运用</div>
          <div class="create-apply-content">
            <div class="empty" v-if="applyList.length == 0">暂无数据</div>
            <div
              class="create-apply-item"
              v-for="(item, index) in applyList"
              :key="index"
              :style="{ backgroundImage: `url(${item.pic})` }"
            >
              <div class="create-apply-bottom">{{ item.title }}</div>
              <div class="learnMore" @click="innovateDetail(item.uuid)">了解更多</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 知产保护 -->
    <div class="box-protect" id="knowledge3">
      <div class="common-title">知产保护</div>
      <div class="box protect-con">
        <div class="empty" v-if="protectList.length == 0">暂无数据</div>
        <div
          v-for="(item, index) in protectList"
          :key="index"
          class="protect"
          @mouseover="protectIndex = index + 1"
          :class="protectIndex == index + 1 || !protectIndex ? '' : 'protectShrink'
        "
          @mouseout="protectIndex = ''"
          @click="innovateDetail(item.uuid)"
        >
          <div class="protectIcon" :style="{ backgroundImage: `url(${item.pic})` }"></div>
          <div class="protectName">{{ item.title }}</div>
          <div class="protectCon">{{ item.summary }}</div>
        </div>
      </div>
    </div>
    <!-- 知产服务 -->
    <div class="box box-service" id="knowledge4">
      <div class="common-title" style="margin-top: 0;">知产服务</div>
      <div class="service-con animate__animated animate__pulse" v-show="showService">
        <div class="empty" v-if="serviceList.length == 0">暂无数据</div>
        <div
          class="service"
          v-for="(item, index) in serviceList"
          :key="index"
          @click="innovateDetail(item.uuid)"
        >
          <div class="serviceIcon" :style="{ backgroundImage: `url(${item.pic})` }"></div>
          {{ item.title }}
        </div>
      </div>
    </div>
    <!-- 项目申报 -->
    <div class="box-declare" id="knowledge5">
      <div class="common-title">项目申报</div>
      <div class="declare-con">
        <el-carousel :interval="500000" arrow="always" class="car" trigger="click">
          <el-carousel-item v-for="(item, index) in programList" :key="index" class="carItem">
            <div class="carList">
              <div class="car-con" v-for="(el, i) in item.list" :key="i" v-show="el">
                <div
                  class="top"
                  v-if="el"
                  :style="{ backgroundImage: `url(${el.pictureUrl})` }"
                >{{ el.policyName }}</div>
                <div class="bottom">
                  <div v-if="el" class="remark over-num-lines num4-lines">{{ el.remark }}</div>
                  <div class="time">
                    <div v-if="el">开始时间：{{ el.startDate }}</div>
                    <div v-if="el">结束时间：{{ el.endDate }}</div>
                  </div>
                </div>
                <div class="detail" @click="GoDetail(el.uuid)">查看详情</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="curp seeMore" @click="projectList">查看更多</div>
      </div>
    </div>
    <!-- 标准管理 -->
    <div class="box-manage" id="knowledge6">
      <div class="common-title">标准管理</div>
      <div class="subTitle">推动标准化与科技创新、产业升级协同发展，提升支撑产业全链条的标准服务能力</div>
      <div class="box manage-con animate__animated animate__zoomIn" v-show="showManage">
        <div class="empty" v-if="protectList.length == 0">暂无数据</div>
        <div
          v-for="(item, index) in manageList"
          :key="index"
          class="manage"
          @click="innovateDetail1(item)"
        >
          <div class="manage-left" :style="{ backgroundImage: `url(${item.pic})` }"></div>
          <div class="manage-right">
            <div class="name">{{ index + 1 + "." + item.title }}</div>
            <div class="content">{{ item.summary }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业风采 -->
    <div class="box-elegant" id="knowledge7">
      <div class="common-title">企业风采</div>
      <div class="box elegant-con">
        <elegantPage />
      </div>
      <dir class="more" @click="checkMore">查看更多</dir>
    </div>
  </div>
</template>
<script>
import { getDictionaryItem, searchRc, getProList } from "../../utils/interface";
import { mapState } from "vuex";
import elegantPage from "./elegant.vue";
// import amap from "../amap/index";
export default {
  name: "innovate",
  components: { elegantPage },
  data() {
    return {
      headerBgUrl: "",
      createList: [
        // {
        //     pic: require("../../assets/publicService/create1.png"),
        //     title: "专利"
        // }
      ], // 知产创造
      applyList: [
        // {
        //     pic: require("../../assets/publicService/apply1.png"),
        //     title: "知识转让"
        // }
      ], // 知产运用
      manageList: [
        // {
        //     pic: require("../../assets/publicService/591.png"),
        //     title: "标准咨询",
        //     summary: "向相关行业投融资平台和媒体以付费订立KPI的形式精准招募项目团队。   "
        // }
      ], // 标准管理
      protectList: [
        // {
        //     pic: require("../../assets/publicService/111.png"),
        //     title: '知识产权保护与维权援助',
        //     summary: '维护知识产权权力人及其厉害关系人合法权益保护社会公共利益'
        // },
      ], // 知产保护
      serviceList: [
        // {title: '测试标题',}
      ], // 知产服务
      protectIndex: "",
      programList: [
        // {
        //   policyName:
        //     "自治区工业和信息化厅关于组织申报国家智能制造优秀场景和示范工厂的通知111",
        //   pictureUrl: require("../../assets/publicService/57.png"),
        //   remark:
        //     "汇聚一批不同行业、汇聚一批不同行业、汇聚一批不同行业、汇聚一批不同行业、汇聚一批不同行业、汇聚一批不同行业、汇聚一批不同行业、汇聚一批不同行业、汇聚一批不同行业、",
        //   startDate: "2023-12-01",
        //   endDate: "2023-12-31",
        // }
      ],
      showManage: false,
      showService: false
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor"
    })
  },
  created() {
    this.getOptionsData();
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    this.searchRc();
    this.getProList();
    if (this.$route.query.code) {
      this.showService = true;
      this.showManage = true;
      let code = this.$route.query.code;
      if (code == "1" || code == "2") {
        this.pageSlide("knowledge1");
      } else {
        this.pageSlide(`knowledge${code}`);
      }
    }
  },
  methods: {
    /* 页面滑动 */
    pageSlide(id) {
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        let top = document.getElementById(id).offsetTop - 80;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: top,
            behavior: "smooth"
          });
        }
      });
    },
    /* 去企业风采列表页 */
    checkMore() {
      let router = this.$router.resolve({
        path: "./elegantList"
      });
      window.open(router.href, "_blank");
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "CXFW_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    // 创新服务页面查询
    searchRc() {
      searchRc().then(res => {
        if (res.success && res.data.length > 0) {
          res.data.map(item => {
            if (item.name == "知产创造") {
              this.createList = item.innovateServiceList;
            } else if (item.name == "知产运用") {
              this.applyList = item.innovateServiceList;
            } else if (item.name == "知产保护") {
              this.protectList = item.innovateServiceList;
            } else if (item.name == "知产服务") {
              this.serviceList = item.innovateServiceList;
            } else if (item.name == "标准管理") {
              this.manageList = item.innovateServiceList;
            }
          });
        } else {
          this.createList = [];
          this.applyList = [];
          this.protectList = [];
          this.serviceList = [];
          this.manageList = [];
        }
      });
    },
    // 项目申报轮播图查询
    getProList() {
      getProList({
        state: 1
      }).then(res => {
        this.programList = [];
        if (res && res.length > 0) {
          res.forEach((el, index) => {
            this.$nextTick(() => {
              let obj = JSON.parse(JSON.stringify({ list: [] }));
              if (index % 2 == 0) {
                obj.list.push(el);
                obj.list.push(res[index + 1]);
                console.log(obj);
                this.programList.push(obj);
              }
            });
          });
          console.log("programList:", this.programList);
        }
      });
    },
    // 进入项目列表页
    projectList() {
      let router = this.$router.resolve({
        path: "./projectApply",
        query: {}
      });
      window.open(router.href, "_blank");
    },
    // 点击了解更多进入创新服务内容详情页
    innovateDetail(uuid) {
      let router = this.$router.resolve({
        path: "./innovateDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(router.href, "_blank");
    },
    // 标准管理进入外部地址
    innovateDetail1(item) {
      console.log(item);
      if (item.url == null || item.url == "") {
        let router = this.$router.resolve({
          path: "./innovateDetail",
          query: {
            uuid: item.uuid
          }
        });
        window.open(router.href, "_blank");
      } else {
        window.location.href = item.url;
      }
    },
    // 进入项目政策详情界面
    GoDetail(uuid) {
      console.log();
      let router = this.$router.resolve({
        path: "./projectApply",
        query: {
          uuid
        }
      });
      window.open(router.href, "_blank");
    },
    onClickLookMore() {},
    // 页面滚动
    menu() {
      let scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log('scroll  ' + scroll)
      if (scroll > 420) {
        this.showService = true;
      }
      if (scroll > 700) {
        this.showManage = true;
      }
    }
  }
};
</script>
style
<style scoped lang="less">
@basic-colors: #009999;
@import "../../assets/css/common.less";

.innovate {
  position: relative;
  top: -80px;

  .top-banner-box {
    // background-color: #f7f8fb;

    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-banner-center {
        width: 1300px;
        height: 500px;
        position: relative;
      }

      .banner-btn {
        width: 130px;
        margin-left: 20px;
        // background-color: white;
        color: transparent;
        letter-spacing: 2px;
        text-align: center;
        padding: 12px 0;
        border-radius: 7px;
        cursor: pointer;
        user-select: none;
        position: absolute;
        bottom: 104px;
        transition: all 0.2s;
      }

      .banner-btn:active {
        transform: scale(1.02);
      }
    }
  }

  .common-title {
    margin: 20px 0;
    background: transparent;
    font-size: 24px;
    font-weight: 700;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .box {
    width: 1300px;
    margin: 0 auto;
    // margin-bottom: 18px;
  }

  .box-service {
    /* 服务 */
    .service-con {
      width: 100%;
      height: 180px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-around;
      align-items: center;

      .service {
        width: 255px;
        height: 114px;
        border-radius: 10px;
        position: relative;
        background-color: #f7f8fc;
        background-clip: content-box;
        box-shadow: 0 0 3px #9999995c;
        box-sizing: border-box;
        font-size: 22px;
        display: flex;
        justify-content: center;
        align-items: end;
        line-height: 3;
        transition: all 0.2s;

        &:hover {
          transform: scale(1.1);
          cursor: pointer;
        }

        &:nth-of-type(1) {
          .serviceIcon {
            background: url("../../assets/publicService/11.png") no-repeat 100%/100%;
          }
        }

        &:nth-of-type(2) {
          .serviceIcon {
            background: url("../../assets/publicService/33.png") no-repeat 100%/100%;
          }
        }

        &:nth-of-type(3) {
          .serviceIcon {
            background: url("../../assets/publicService/44.png") no-repeat 100%/100%;
          }
        }

        &:nth-of-type(4) {
          .serviceIcon {
            background: url("../../assets/publicService/22.png") no-repeat 100%/100%;
          }
        }

        .serviceIcon {
          position: absolute;
          left: 50%;
          top: -60%;
          transform: translateX(-50%);
          width: 160px;
          height: 130px;
        }
      }
    }
  }

  /* 标准管理 */
  .box-manage {
    height: 580px;
    width: 100%;
    background-color: #f3f5fb;
    overflow: hidden;

    .common-title {
      margin: 15px 0 10px;
    }

    .subTitle {
      text-align: center;
      color: #555252;
    }

    .manage-con {
      width: 1300px;
      height: 460px;
      margin-top: 30px;
      display: flex;
      flex-flow: column wrap;
      justify-content: start;
      align-items: center;

      .manage {
        width: 500px;
        height: 130px;
        margin: 5px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          transform: scale(1.1);
        }

        .manage-left {
          width: 102px;
          height: 80%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .manage-right {
          width: 350px;
          height: 80%;

          .name {
            color: #2d50a1;
            font-size: 24px;
            font-weight: 600;
            margin-top: 5px;
          }

          .content {
            color: #524f4f;
            margin-top: 5px;
          }
        }
      }
    }
  }

  /* 知产创造 + 知产运用 */
  .box-create-apply {
    width: 100%;
    height: 360px;
    background-color: #f2f2f4;
    overflow: hidden;

    .create-apply-con {
      width: 1300px;
      margin: 0 auto;
      padding-top: 15px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;

      .create-con,
      .apply-con {
        width: 630px;
        height: 330px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;

        .create-apply-title {
          background: transparent;
          font-size: 24px;
          font-weight: 700;
          color: #000;
        }

        .create-apply-content {
          flex: 1;
          width: 100%;
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: center;
          position: relative;

          .create-apply-item {
            width: 145px;
            height: 280px;
            border: 1px solid #e4eded;
            border-radius: 18px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: relative;

            .create-apply-bottom {
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              font-size: 21px;
              font-weight: 600;
              color: #1d1d1d;
              padding-top: 40px;
            }

            &:hover {
              cursor: pointer;
              background-color: rgb(3 86 227 / 80%);
              background-blend-mode: multiply;

              .create-apply-bottom {
                color: #fff;
              }

              .learnMore {
                display: block;
                font-weight: 600;
                font-size: 14px;
                // background-color: rgb(250, 254, 254, 1);
                background-color: rgba(249, 251, 252, 0.2);
              }

              // &:nth-of-type(1) {
              //     background-image: url('../../assets/publicService/create11.png') !important;
              // }

              // &:nth-of-type(2) {
              //     background-image: url('../../assets/publicService/create22.png') !important;
              // }

              // &:nth-of-type(3) {
              //     background-image: url('../../assets/publicService/create33.png') !important;
              // }

              // &:nth-of-type(4) {
              //     background-image: url('../../assets/publicService/create44.png') !important;
              // }
            }

            .learnMore {
              display: none;
              width: 80px;
              height: 18px;
              line-height: 18px;
              padding: 5px;
              position: absolute;
              bottom: 85px;
              left: 50%;
              transform: translateX(-50%);
              border: 1px solid #a8b8c7;
              border-radius: 4px;
              text-align: center;
              color: #fff;
              font-size: 14px;
              background-color: rgb(168 184 199 / 0%);
            }
          }
        }
      }

      .create-con {
      }

      .apply-con {
        .create-apply-content {
          // .create-apply-item {
          //     &:hover {
          //         &:nth-of-type(1) {
          //             background-image: url('../../assets/publicService/apply11.png') !important;
          //         }

          //         &:nth-of-type(2) {
          //             background-image: url('../../assets/publicService/apply22.png') !important;
          //         }

          //         &:nth-of-type(3) {
          //             background-image: url('../../assets/publicService/apply33.png') !important;
          //         }

          //         &:nth-of-type(4) {
          //             background-image: url('../../assets/publicService/apply44.png') !important;
          //         }
          //     }
          // }
        }
      }
    }
  }

  /* 知产保护 */
  .box-protect {
    width: 100%;
    // background-color: #F2F2F4;
    overflow: hidden;

    .protect-con {
      width: 1300px;
      height: 270px;
      margin-top: 20px;
      // padding: 25px 0;
      display: flex;
      flex-flow: column wrap;
      justify-content: start;
      align-items: center;
      // box-shadow: 0 0 6px #9999998a;
      box-sizing: border-box;
      // border: 1px solid #efefef;
      border-radius: 10px;
      position: relative;

      .protect {
        width: 25%;
        height: 270px;
        padding: 0 15px;
        box-sizing: border-box;
        // border-right: 1px solid #e3e5f4;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        transition: all 0.4s;
        text-align: center;

        & > div {
          margin: 8px 0;
          width: 295px;
        }

        &:last-child {
          border: none;
        }

        .protectIcon {
          width: 110px;
          height: 105px;
          background: no-repeat 100%/100%;
        }

        .protectName {
          color: #2d50a1;
          font-size: 18px;
          font-weight: 600;
          width: 50%;
        }

        &:hover {
          width: 35%;
          cursor: pointer;
          background: url("../../assets/publicService/59.png") no-repeat 92%/130%;

          .protectIcon {
            transform: scale(1.06);
          }
        }
      }

      .protectShrink {
        width: 17%;
      }
    }
  }

  /* 项目申报 */
  .box-declare {
    width: 100%;
    overflow: hidden;

    .declare-con {
      height: 480px;

      .seeMore {
        width: 1300px;
        margin: 15px auto;
        text-align: center;
      }

      .car {
        box-sizing: border-box;

        .carItem {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: center;

          .carList {
            width: 1300px;
            height: 422px;
            margin: 0 auto;
            display: flex;
            flex-flow: row nowrap;

            .car-con {
              width: 590px;
              height: 420px;
              margin: 0 auto;
              border-radius: 12px;
              display: flex;
              flex-flow: column nowrap;
              // box-shadow: 0 0 8px #e3e5f4;
              border: 1px solid #efefef;

              .top {
                height: 150px;
                border-radius: 12px;
                border-bottom-left-radius: 0px;
                border-bottom-right-radius: 0px;
                color: #fff;
                padding: 20px 20px;
                box-sizing: border-box;
                font-size: 20px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                line-height: 35px;
              }

              .bottom {
                flex: 1;
                display: flex;
                flex-flow: column nowrap;
                justify-content: start;
                align-items: start;
                padding: 20px 40px;

                .remark {
                  height: 100px;
                  color: #555555;
                  line-height: 25px;
                }

                .time {
                  margin-top: 15px;
                  color: #2d50a1;
                  font-weight: bold;
                  line-height: 28px;
                }
              }

              .detail {
                cursor: pointer;
                width: 100px;
                height: 30px;
                line-height: 30px;
                background-color: #2d50a1;
                border-radius: 15px;
                color: #fff;
                font-size: 14px;
                text-align: center;
                align-self: center;
                margin-bottom: 20px;
              }
            }
          }
        }
      }
    }
  }

  /* 企业风采 */
  .box-elegant {
    width: 100%;
    overflow: hidden;
    background: url("../../assets/publicService/elegant.png") center center /
      100% 100% no-repeat;
    margin-bottom: -80px;

    .elegant-con {
      height: 480px;
    }
    .more {
      position: absolute;
      bottom: 72px;
      left: 50%;
      transform: translateX(-50%);
      color: #2d50a1;
      border: 1px solid #2d50a1;
      width: 90px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
    }
  }
}

/deep/ .el-carousel__container {
  height: 425px;
}

/deep/ .el-carousel__arrow {
  box-shadow: 0 0 3px #999999;
}

/deep/ .el-carousel__arrow--left {
  left: 280px;
}

/deep/ .el-carousel__arrow--right {
  right: 280px;
}
</style>



// WEBPACK FOOTER //
// src/components/innovateService/index.vue